import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import '../../styles/app/FAQAccordion.css';

const faqs = [
    {
        question: "¿Por qué elegir elPaket?",
        answer: "Ofrecemos tarifas transparentes, tracking real 24/7, seguro y cobertura en más de 300 destinos."
    },
    {
        question: "¿Cuánto tiempo tarda en llegar mi paquete?",
        answer: "Los envíos aéreos toman de 7 a 15 días hábiles dependiendo del destino. Los marítimos viajan en un rango de entre 4 a 6 semanas. Los tiempos pueden variar por procesos aduanales o temporada alta."
    },
    {
        question: "¿Ofrecen servicio puerta a puerta en todos los países?",
        answer: "Sí, entregamos puerta a puerta en más de 300 ciudades de: Costa Rica, Guatemala, Perú, República Dominicana y Venezuela. Zonas remotas pueden requerir coordinación o tarifa adicional."
    },
    {
        question: "¿Desde dónde puedo enviar?",
        answer: "Puedes enviar desde cualquiera de los 50 estados de USA. Programa la recogida UPS en tu casa u oficina, o entrega tu paquete en la tienda UPS más cercana."
    },
    {
        question: "¿Qué artículos NO puedo enviar (Prohibidos)?",
        answer: (
            <>
                Está prohibido enviar armas, explosivos, drogas, dinero en efectivo, joyas, carnes/embutidos y material pornográfico.{' '}
                <Link to="/articulos-prohibidos" style={{ color: 'var(--color-primary)', fontWeight: '600', textDecoration: 'underline' }}>
                    Consulta la lista completa aquí.
                </Link>
            </>
        )
    }
];

const FAQAccordion: React.FC = () => {
    const [activeIndex, setActiveIndex] = useState<number | null>(0);

    const toggleAccordion = (index: number) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <div className="faq-container">
                <div className="faq-header">
                    <h2>Preguntas Frecuentes</h2>
                    <p>Resolvemos tus dudas sobre envíos a Latinoamérica</p>
                </div>

                <div className="faq-list">
                    {faqs.map((faq, index) => (
                        <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                            <button className="faq-question" onClick={() => toggleAccordion(index)}>
                                <span>{faq.question}</span>
                                <FontAwesomeIcon icon={activeIndex === index ? faChevronUp : faChevronDown} />
                            </button>
                            <div className="faq-answer" style={{ maxHeight: activeIndex === index ? '200px' : '0' }}>
                                <p>{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="faq-footer">
                    <Link to="/preguntas-frecuentes" className="faq-view-more-btn">
                        Ver todas las preguntas frecuentes
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default FAQAccordion;
